import React from 'react';
import addIfMissingComponent from '../util/addIfMissingComponent';

const Body = ({ children }) => (<>{addIfMissingComponent(children, "BodyComponent")}</>);

export default Body;
